export default __webpack_public_path__ + "static/media/2312.a9b28d94.png";